import { isEmpty } from 'lodash'
import { toColor } from '../../../utils/ColorTransformator'
import { EventStatus } from '../../Event'
import { colors } from '../../Event/eventConfig'
import { ISettings } from '../index'
import { IObjectData } from '../request/response'
import { customColorsArray } from '../../../reducers/bookingCalendar/initialState'
import { fromAhexToHexa } from '../../../utils/ColorTransformator/aHexTransformer'
import unserialize from '../../../utils/unserialize'
import { IRequestCustomStatus } from './mapValuesToRequestSettings'

function matchReservationAppearance(app: string): 'diamond' | 'square' {
  return app === '0' ? 'diamond' : 'square'
}

export function mapWeekDaysToArray(arr: string) {
  let days: number[]
  days = Array.from(new Array(7)).map(_ => 0)
  if (!isEmpty(arr) && arr !== 'null') {
    try {
      days = JSON.parse(arr)
    } catch (e) {
      console.error(e)
    }
  }
  return days.map(e => !!e)
}

function matches(color: string, type: EventStatus) {
  if (
    color &&
    customColorsArray.find(
      c => c.toLowerCase() === fromAhexToHexa(color).toLowerCase(),
    )
  ) {
    return color
  }
  return colors.get(type)
}

export default function(item: IObjectData): ISettings {
  const reservationNames = item.custom_reservation_status_names || []
  const reservationColors = item.custom_reservation_status_colors
    ? item.custom_reservation_status_colors.map(value =>
        value === '#0' ? null : value,
      )
    : []

  return {
    show_busy_terms: item.show_busy_terms === '1',
    cancelFree: item.cancel_free || '0',
    cancelPay: item.cancel_pay || '0',
    customReservationStatus: {
      colors: {
        [EventStatus.Advance]: toColor(
          matches(
            reservationColors[IRequestCustomStatus.Advance],
            EventStatus.Advance,
          ),
        ),
        [EventStatus.Canceled]: toColor(
          matches(
            reservationColors[IRequestCustomStatus.Canceled],
            EventStatus.Canceled,
          ),
        ),
        [EventStatus.Full]: toColor(
          matches(
            reservationColors[IRequestCustomStatus.Full],
            EventStatus.Full,
          ),
        ),
        [EventStatus.Unavailable]: toColor(
          matches(
            reservationColors[IRequestCustomStatus.Unavailable],
            EventStatus.Unavailable,
          ),
        ),
        [EventStatus.NoPayment]: toColor(
          matches(
            reservationColors[IRequestCustomStatus.NoPayment],
            EventStatus.NoPayment,
          ),
        ),
      },
      names: {
        [EventStatus.Advance]:
          reservationNames[IRequestCustomStatus.Advance] || '',
        [EventStatus.Canceled]:
          reservationNames[IRequestCustomStatus.Canceled] || '',
        [EventStatus.Full]: reservationNames[IRequestCustomStatus.Full] || '',
        [EventStatus.Unavailable]:
          reservationNames[IRequestCustomStatus.Unavailable] || '',
        [EventStatus.NoPayment]:
          reservationNames[IRequestCustomStatus.NoPayment] || '',
      },
    },
    daynightFrom:
      item.daynightFrom && item.daynightFrom !== ''
        ? item.daynightFrom
        : '14:00',
    daynightTo:
      item.daynightTo && item.daynightTo !== '' ? item.daynightTo : '10:00',
    defaultFeedingType: item.default_service,
    defaultPrepaidType: item.prepayment_type,
    defaultReservationStatus: item.default_reservation_status,
    eventLabel:
      item.reservation_appearance_label &&
      item.reservation_appearance_label !== null
        ? item.reservation_appearance_label.join(' ')
        : '#Guest.name#', // Was: '#Source.of.booking.origin# #Guest.name#' — BED-40785
    eventShape: matchReservationAppearance(item.reservation_appearance),
    id: Number(item.id),
    prepayment_type: item.prepayment_type,
    provision: handleProvision(
      item.provision ? unserialize(item.provision) : '',
    ), //Fix for when empty from api
    serviceBedding: Number(item.room_service_bedding),
    serviceBeddingDays: mapWeekDaysToArray(item.room_service_bedding_days),
    serviceBeddingStatus: Number(item.room_service_bedding_status),
    serviceCleaning: Number(item.room_service_cleaning),
    send_mail_client_reservation: item.send_mail_client_reservation
      ? item.send_mail_client_reservation
      : '0',
    send_mail_reservation: item.send_mail_reservation
      ? item.send_mail_reservation
      : '0',
    serviceCleaningDays: mapWeekDaysToArray(item.room_service_cleaning_days),
    serviceCleaningStatus: Number(item.room_service_cleaning_status),
    serviceTowels: Number(item.room_service_towels),
    serviceTowelsDays: mapWeekDaysToArray(item.room_service_towels_days),
    serviceTowelsStatus: Number(item.room_service_towels_status),
    pricelist_multi: Boolean(Number(item.pricelist_multi)),
    pricelist_multi_can_switch: Boolean(
      Number(item.pricelist_multi_can_switch),
    ),
    summary: {
      checkinout: item.show_summary_checks && item.show_summary_checks === '1',
      feeding: item.show_summary_food && item.show_summary_food === '1',
      fulfillment:
        item.show_summary_persons && item.show_summary_persons === '1',
    },
  }
}

function handleProvision(provision) {
  if (!provision || !provision.find(p => Number(p.days) === 0)) {
    return [{ days: 0, percent: 30 }, ...provision]
  }
  return provision
}
